import { List, ListItem, ListItemText, Paper, Popper, Typography } from '@mui/material';
import React from 'react';

// Alternativas cuando el detalle no cabe en la posición pedida.
const FALLBACK_PLACEMENTS = {
    'right-start': ['left-start', 'bottom-start', 'top-start'],
    'bottom-start': ['top-start'],
};

const OrderDeliveryDetailsPopover = ({ item, anchorElement, placement = 'bottom-start' }) => {
    const open = Boolean(anchorElement);

    if (!item) return null;

    return (
        <Popper
            id="mouse-over-popover"
            sx={{ pointerEvents: 'none', zIndex: (theme) => theme.zIndex.modal }}
            open={open}
            anchorEl={anchorElement}
            placement={placement}
            modifiers={[
                /* Si no cabe donde se pidió (abajo de la caja, o a su derecha
                   cuando todavía no hay rutas), se voltea al lado opuesto. */
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: FALLBACK_PLACEMENTS[placement] || ['top-start'],
                        padding: 8,
                    },
                },
                { name: 'preventOverflow', options: { padding: 8 } },
                { name: 'offset', options: { offset: [0, 4] } },
            ]}
        >
            <Paper elevation={8}>
                <List
                    sx={{
                        width: 'min(360px, calc(100vw - 32px))',
                        maxHeight: '45vh',
                        overflowY: 'auto',
                    }}
                    dense
                >
                    {item.order_details?.map((value) => {
                        const hasMissingBarcode = !value.product_barcode;

                        return (
                            <ListItem
                                alignItems="flex-start"
                                key={value.id}
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'minmax(0, 1fr) auto',
                                    columnGap: 1.5,
                                }}
                            >
                                <ListItemText
                                    sx={{ minWidth: 0, my: 0 }}
                                    primary={
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: hasMissingBarcode ? 'error.main' : 'text.primary',
                                                fontWeight: hasMissingBarcode ? 500 : 400,
                                                overflowWrap: 'anywhere',
                                            }}
                                        >
                                            {value.product_code} – {value.product}
                                        </Typography>
                                    }
                                />
                                <Typography
                                    variant="body2"
                                    color={hasMissingBarcode ? 'error.main' : 'text.primary'}
                                    sx={{ whiteSpace: 'nowrap' }}
                                >
                                    {value.pending_qty} {value.meassure_unit}
                                </Typography>
                            </ListItem>
                        );
                    })}
                </List>
            </Paper>
        </Popper>
    );
};

export default OrderDeliveryDetailsPopover;
